/* eslint-disable */

import { useEffect, useState } from 'react'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '../../Components/ui/input-otp'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import useMediaQuery from '../../hooks/useMediaQuery'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../Components/ui/dialog'
import { post } from '../../http/restservice'
import env from '../../env/env'
import { Button } from '../../Components/ui/button'
import CachedSharpIcon from '@mui/icons-material/CachedSharp'
import PostHogTracker from '../../utils/PostHogTracker'
import { SwipeableDrawer } from '@mui/material'

const OTPContent = ({
  otp,
  setOtp,
  errorMessage,
  loading,
  setLoading,
  phoneNumber,
  verifyOTP,
  isVerified,
  counter,
  generateOTP,
  email,
}) => (
  <div className='flex flex-col space-y-4 w-full font-DMSans p-4'>
    <div className='text-center space-y-2'>
      <h1 className='font-semibold text-2xl leading-8'>Verify OTP</h1>
      <p className='text-sm leading-5 text-black-400'>
        OTP successfully sent to{' '}
        <b>
          {phoneNumber} and {email}
        </b>
      </p>
    </div>

    <div className='flex justify-center items-center'>
      {counter == 0 ? (
        <button
          onClick={() => {
            setLoading(true)
            generateOTP()
          }}
          className='flex flex-row items-center justify-center cursor-pointer whitespace-nowrap font-DMSans text-[14px] kerning-[20px] font-semibold text-primary-500 gap-x-1 border-b-[2px] border-dashed border-primary-500'
        >
          <CachedSharpIcon className='text-primary-500' sx={{ fontSize: '20px' }} />
          Resend OTP
        </button>
      ) : (
        <div className='flex flex-row justify-center items-center gap-x-1 border-b-[2px] border-transparent'>
          <CachedSharpIcon className=' text-black-400' sx={{ fontSize: '20px' }} />
          <p className='flex flex-row whitespace-nowrap font-DMSans text-[14px] kerning-[20px] font-medium text-black-400'>
            {' '}
            Resend OTP in <span className='font-semibold text-black-500'>&nbsp;{counter} sec</span>
          </p>
        </div>
      )}
    </div>

    <InputOTP
      maxLength={6}
      pattern={REGEXP_ONLY_DIGITS}
      value={otp}
      onChange={(value) => setOtp(value)}
      disabled={isVerified}
    >
      <InputOTPGroup>
        {[...Array(6)].map((_, index) => (
          <InputOTPSlot
            key={index}
            className={`${
              errorMessage && 'border-error-600 text-error-600 font-medium'
            } border-[#D3DBEC] text-[16px] kerning-[24px] py-3 px-4 !h-[48px]`}
            index={index}
          />
        ))}
      </InputOTPGroup>
    </InputOTP>

    <div className='text-center text-xs text-error-600 font-medium mt-2'>
      {errorMessage && <>{errorMessage}</>}
    </div>

    <Button
      disabled={otp.length !== 6}
      className={`w-full ${otp.length !== 6 ? 'bg-primary-300' : 'bg-primary-500'}`}
      onClick={() => {
        setLoading(true)
        verifyOTP()
      }}
    >
      Verify
    </Button>
  </div>
)

const OTPVerification = ({
  phoneNumber,
  openOTPPopup,
  setOpenOTPPopup,
  isVerified,
  setIsVerified,
  email,
}) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)')
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const [otp, setOtp] = useState('')
  const [counter, setCounter] = useState(45)

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
    return () => clearInterval(timer)
  }, [counter])

  const verifyOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/verifyTransactionalOtp`,
      {
        phoneNumber: phoneNumber,
        otp: otp,
      },
    )

    if (response?.isError) {
      PostHogTracker.buttonClicked('OTP Button', {
        action: 'Order OTP Verification Failed',
        page_name: 'Action Center Orders Page',
      })

      setErrorMessage(response?.response)
      return
    }

    if (response?.includes('Successfully verified otp')) {
      PostHogTracker.buttonClicked('OTP Button', {
        action: 'Order OTP Verification Successful',
        page_name: 'Action Center Orders Page',
      })

      setIsVerified(true)
      setOpenOTPPopup(false)
      setOtp('')
      setLoading(false)
    }
  }

  const generateOTP = async () => {
    const response = await post(
      `${env.API_URL}mutualfundservice/api/mutualFund/sendTransactionalOtp`,
      {
        phoneNumber: phoneNumber,
        email: email,
      },
    )

    if (response.isError) {
      PostHogTracker.buttonClicked('OTP Button', {
        action: 'Order OTP Resend Failed',
        page_name: 'Action Center Orders Page',
      })

      showError('OTP Error', 'Failed to generate OTP. Please try again later.', () => {})
    }

    if (!response.isError) {
      PostHogTracker.buttonClicked('OTP Button', {
        action: 'Order OTP Resend Successfully',
        page_name: 'Action Center Orders Page',
      })

      setCounter(45)
    }
  }

  return (
    <>
      {isDesktop ? (
        <div className='p-4'>
          <Dialog open={openOTPPopup} onOpenChange={setOpenOTPPopup}>
            <DialogContent
              className='sm:max-w-[600px] max-h-[90vh] overflow-y-auto hide-scrollbar'
              showclose={true}
            >
              <DialogHeader>
                <DialogTitle className='sr-only'>SIP Confirmation</DialogTitle>
              </DialogHeader>
              <OTPContent
                otp={otp}
                setOtp={setOtp}
                errorMessage={errorMessage}
                loading={loading}
                setLoading={setLoading}
                phoneNumber={phoneNumber}
                verifyOTP={verifyOTP}
                isVerified={isVerified}
                counter={counter}
                generateOTP={generateOTP}
                email={email}
              />
            </DialogContent>
          </Dialog>
        </div>
      ) : (
        <div className='p-4'>
          {/* <Sheet open={openOTPPopup} onOpenChange={() => setOpenOTPPopup()}>
            <SheetContent side='bottom' showClose={true} className='h-auto rounded-t-3xl'>
              <SheetHeader className='text-left'>
                <SheetTitle className='sr-only'>SIP Confirmation</SheetTitle>
              </SheetHeader> */}
          <SwipeableDrawer
            anchor='bottom'
            open={openOTPPopup}
            onOpen={() => setOpenOTPPopup()}
            onClose={() => setOpenOTPPopup()}
            sx={{
              '& .MuiPaper-root': {
                borderTopRightRadius: '24px',
                borderTopLeftRadius: '24px',
              },
            }}
          >
            <OTPContent
              otp={otp}
              setOtp={setOtp}
              errorMessage={errorMessage}
              loading={loading}
              setLoading={setLoading}
              phoneNumber={phoneNumber}
              verifyOTP={verifyOTP}
              isVerified={isVerified}
              counter={counter}
              generateOTP={generateOTP}
              email={email}
            />
          </SwipeableDrawer>
          {/* </SheetContent>
          </Sheet> */}
        </div>
      )}
    </>
  )
}

export default OTPVerification
